import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  planoAPI,
  useGetActivitesQuery,
  useGetPlanoQuery,
} from "../../../redux/features/cache";
import FormEditMagasinProduit from "./FormEditMagasinProduit";
import FormEditProduit from "./Forms/FormEditProduit";
import { Activite } from "../../../models/Activite";
import { Planogramme } from "../../../models/Planogramme";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import ModificationLotMagasins from "./ModificationLotMagasins";
import useGetPollingInterval from "../../../hooks/useGetPollingInterval";

interface IWrapperEditMagasin {
  prod: any;
  setUnsaved: Dispatch<SetStateAction<boolean>>;
  setOpenNewProduit: any;
  setListMags: any;
  setAddProductTitle: any;
  setOpenModalEdit: any;
  setSelectedRow: any;
}

function WrapperEditMagasin(props: IWrapperEditMagasin) {
  const {
    prod,
    setUnsaved,
    setOpenNewProduit,
    setListMags,
    setAddProductTitle,
    setOpenModalEdit,
    setSelectedRow,
  } = props;
  const pollingInterval = useGetPollingInterval();
  const { data: planogrammes = [] as Planogramme[] } = useGetPlanoQuery(
    { prod: prod, statut: "", ban: "", mag: "", manquant: false },
    { pollingInterval: pollingInterval }
  );
  const { data: activites = [] as Activite[] } = useGetActivitesQuery(false);
  const [listChecked, setListchecked] = useState<Planogramme[]>(
    [] as Planogramme[]
  );
  const d_inv01rp = useAppSelector((state) => state.appState.d_inv01rp);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let listMagasins = planogrammes.map((e) => e.magasin);
    let checkedMagasins = planogrammes.filter((e) => e.isChecked == true);
    setListchecked(checkedMagasins);
    setListMags(listMagasins);
  }, [planogrammes]);

  const handleChange = (index: number) => {
    dispatch(
      planoAPI.util.updateQueryData(
        "getPlano",
        { prod: prod, statut: "", ban: "", mag: "", manquant: false },
        (planogramme) => {
          planogramme[index].isChecked = !planogramme[index].isChecked;
          return planogramme;
        }
      )
    );
  };

  const handleAll = (e: any) => {
    dispatch(
      planoAPI.util.updateQueryData(
        "getPlano",
        { prod: prod, statut: "", ban: "", mag: "", manquant: false },
        (planogramme) => {
          planogramme.forEach((x) => {
            if (!e.target.checked) {
              x.isChecked = false;
            } else {
              x.isChecked = true;
            }
          });
          return planogramme;
        }
      )
    );
  };

  return (
    <>
      {planogrammes.length > 0 && (
        <Box>
          <FormEditProduit
            produit={planogrammes[0].produit}
            section={planogrammes[0].section}
            allCode={activites}
            setUnsaved={setUnsaved}
          />
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", ml: 2, color: "#007bff" }}
            >
              Magasins
            </Typography>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#007bff", borderRadius: "30px", m: 1 }}
              onClick={() => {
                setOpenNewProduit(true);
                setAddProductTitle("Ajouter un magasin");
              }}
              disabled={!d_inv01rp.canAdd}
            >
              Ajouter un magasin
            </Button>
          </Box>
          <Divider
            variant="middle"
            sx={{ backgroundColor: "#007bff", mb: 4 }}
          />
        </Box>
      )}
      {listChecked.length > 0 && (
        <>
          <ModificationLotMagasins
            listMag={listChecked}
            setOpenModalEdit={setOpenModalEdit}
            setSelectedRow={setSelectedRow}
            setListMags={setListMags}
            prod={prod}
          />
          <Divider
            variant="middle"
            sx={{ backgroundColor: "#007bff", mb: 4 }}
          />
        </>
      )}
      <FormControlLabel
        control={<Checkbox checked={listChecked.length > 0} />}
        label="Tous les magagsins"
        onClick={(e) => handleAll(e)}
      />
      {planogrammes.map((e, i) => (
        <Box
          sx={{ display: "flex", borderBottom: "1px black solid", m: 1, alignItems: "center" }}
          key={i}
        >
          <Checkbox
            checked={e.isChecked}
            onChange={(e) => {
              handleChange(i);
            }}
            key={Math.random()}
          />
          <FormEditMagasinProduit
            data={e}
            index={i}
            key={`${e.plano_seq}`}
            setUnsaved={setUnsaved}
            listChecked={listChecked}
          />
        </Box>
      ))}
    </>
  );
}

export default React.memo(WrapperEditMagasin);
